<!-- 
Belstaff internal feature
UI component for adding a gift card with recipient details to basket
 -->
<script lang="ts">
  import { _ } from "svelte-i18n";
  import { createEventDispatcher } from "svelte";

  import Typography from "$lib/components/Typography/Typography.svelte";
  import InputField from "$lib/components/InputField/InputField.svelte";

  import Icon from "$lib/components/Icon/Icon.svelte";
  import Checkbox from "../Checkbox/Checkbox.svelte";
  import type {
    MoneyV2,
    SelectedOptionInput as Option,
  } from "$lib/gql/gen/codegen";
  import Button from "../Button/Button.svelte";

  type Variant = {
    id: string;
    title: string;
    sku?: string;
    price: MoneyV2;
    compareAtPrice?: MoneyV2;
    selectedOptions: Option[];
  };

  export let withPadding = false;
  export let closeButton = false;

  export let formTitle = "Gift Card Form";
  export let email = "";
  export let name = "";
  export let message = "";
  export let date = new Date().toISOString().split("T")[0];

  export let sendOnDate = false;

  $: validDate =
    new Date(date).toISOString().split("T")[0] >=
    new Date().toISOString().split("T")[0];

  let giftCardForm: HTMLFormElement;

  const dispatch = createEventDispatcher();

  const close = () => {
    dispatch("close");
  };

  const onAddToBasket = () => {
    dispatch("addToBasket");
  };
</script>

<style lang="scss">
  .newsletter-signup {
    &--check-wrapper {
      position: absolute;
      left: -9999px;
      visibility: hidden;
    }

    &--gender {
      display: flex;
      align-items: flex-start;
      margin-top: 22px;
    }
  }
  .accordion {
    &--padded {
      padding: 24px 32px;

      @include breakpoint(md) {
        padding: 24px 44px;
      }

      @include breakpoint(lg) {
        padding: 16px;
      }
    }

    &--close {
      background-color: transparent;
      border: none;
      position: absolute;
      top: 0;
      right: 0;
      padding: 8px;
    }

    .input-field-container {
      z-index: 100;
      padding-top: 24px;
    }
  }

  .inline-anchor {
    cursor: pointer;
  }

  :global(.input-field-container label input.checkbox) {
    min-width: 20px;
    max-height: 20px;
  }

  :global(.bis--form .input-field-container .checkbox input) {
    border-radius: 14px;
  }

  :global(.bis--form .input-field-container .checkbox input:checked::before) {
    display: none;
  }

  :global(.date-time-field > input) {
    --date-input-width: 100%;
    font-family: "Proxima Nova", sans-serif !important;
    padding: 10.5px 20px !important;
    border: 1px solid rgba(0, 0, 0, 0.2) !important;
    font-size: 16px !important;
    line-height: 22px !important;
    min-width: 270px !important;
    border-radius: 24px !important;
  }

  :global(.date-time-field > .picker) {
    z-index: 100;
  }
</style>

<div class={`accordion ${withPadding && "accordion--padded"} `}>
  {#if closeButton}
    <button class="accordion--close" on:click={close}>
      <Icon icon="close" />
    </button>
  {/if}
  <div>
    <Typography component="h3" theme="on-background" variant="button1"
      >{$_("giftcard.header")}</Typography
    >
    <form
      class="bis--form"
      title={formTitle}
      bind:this={giftCardForm}
      on:submit|preventDefault={onAddToBasket}
    >
      <div class="input-field-container">
        <InputField
          placeholder={`${$_("Email")} *`}
          label={$_("Email")}
          type="email"
          name="email"
          fullWidth
          required
          bind:value={email}
        />
      </div>
      <div class="input-field-container">
        <InputField
          placeholder={`${$_("Name")} (${$_("optional")})`}
          label={$_("Name")}
          type="text"
          name="name"
          fullWidth
          bind:value={name}
        />
      </div>
      <div class="input-field-container">
        <InputField
          placeholder={`${$_("Message")} (${$_("optional")})`}
          label={$_("Message")}
          type="text"
          name="message"
          fullWidth
          bind:value={message}
        />
      </div>
      <div class="input-field-container">
        <Checkbox
          label={$_("giftcard.body")}
          placeholder={$_("giftcard.body")}
          type="checkbox"
          bind:checked={sendOnDate}
        />
      </div>
      {#if sendOnDate}
        <div class="input-field-container">
          <InputField
            bind:value={date}
            required
            type="date"
            fullWidth
            error={!validDate}
            errorMessage={!validDate &&
              $_("Date must be today, or in the future")}
          />
        </div>
      {/if}

      <div class="input-field-container">
        <Button
          primary
          fullWidth
          disabled={!email && email === ""}
          on:click
          label={$_("Add to Bag")}
          submit
        />
      </div>
    </form>
  </div>
</div>
